module.exports = __webpack_public_path__ + "img/crowd_blob_2.5d12a686.png";